<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Settings</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <p style="margin-top:20px;text-align: left"><v-btn v-on:click="sho1(); activate(1);" :class="[(active_el === 1 ) ? 'active_el' : 'default']" flat>Create User</v-btn> / <v-btn v-on:click="sho2(); activate(2); " :class="[(active_el === 2 ) ? 'active_el' : 'default']" flat>View Role</v-btn>/ <v-btn v-on:click="sho3(); activate(3); " :class="[(active_el === 3 ) ? 'active_el' : 'default']" flat>Permission</v-btn></p>
                                <v-dialog
                                    v-model="dialog"
                                    width="800"
                                    v-show="show1"
                                  >
                                    <v-btn class="primary" style="margin-left:500px;margin-top: 10px" slot="activator">Add User</v-btn>
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Add User
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6 style="margin-left:80px">
                                                <label style="text-align: left">Full Name</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">User Name</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Email Address</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Mobile Number</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Role</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                                <label style="text-align: left">Password</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Country</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog = false"
                                        >
                                          Create User
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                  </v-layout>
                  <v-flex style="text-align: left" v-show="show1">
                    <h3 style="margin-top:10px;margin-bottom:10px">User Overview</h3>
                    <p>User Registered For Wynum Logistics</p>
                    <p>Kindly note that following person have access to your booking details. If a person in this list left organisation then please deactive them</p>
                  <v-divider divider: true></v-divider>
                  <h3 style="text-align: left;margin-bottom: 10px;margin-top:20px">User List</h3>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                    v-show="show1"
                    style="width:1200px"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.name}}</td>
                      <td class="text-xs-left">{{ props.item.username}}</td>
                      <td class="text-xs-left">{{ props.item.email}}</td>
                      <td class="text-xs-left">{{ props.item.mobileno}}</td>
                      <td class="text-xs-left">{{ props.item.role}}</td>
                      <td class="text-xs-left">{{ props.item.password}}</td>
                      <td class="text-xs-left">{{ props.item.country}}</td>
                      <td class="text-xs-left"><v-layout row wrap><v-switch v-model="switch1" style=""></v-switch> | <v-icon flat @click="dialog1 = true" style="margin-left:20px;margin-top:-10px">edit</v-icon></v-layout></td>
                    </template>
                  </v-data-table>
                                  <v-dialog
                                    v-model="dialog1"
                                    width="800"
                                  >
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Edit User
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6 style="margin-left:80px">
                                                <label style="text-align: left">Full Name</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">User Name</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Email Address</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Mobile Number</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Role</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                                <label style="text-align: left">Password</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                                <label style="text-align: left">Country</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog1 = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog1 = false"
                                        >
                                          Update
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                    </v-flex>
                    <v-flex style="text-align: left" v-show="show2">
                      <v-layout row wrap>
                        <v-flex xs1></v-flex>
                        <v-flex xs3 style="margin-left:20px">
                          <v-card style="margin-top:20px;height:360px">
                            <v-card-text>
                              <h3 style="text-align: left;margin-bottom: 10px;color:blue">Role: Admin</h3>
                              <v-divider divider: true></v-divider>
                                <p style="margin-top:20px">Book Shipment (Regular & Bulk)</p>
                                <p>Submit & Amend Shipping Instructions</p>
                                <p>See Transport Documents</p>
                                <p>Way Bill</p>
                                <p>Container Management</p>
                                <p>Address Book</p>
                                <p>AME Track</p>
                                <p>Dashboard</p>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex xs3 style="margin-left:20px">
                          <v-card style="margin-top:20px;height:360px">
                            <v-card-text>
                              <h3 style="text-align: left;margin-bottom: 10px;color:blue">Role: Manager</h3>
                              <v-divider divider: true></v-divider>
                                <p style="margin-top:20px">Book Shipment (Regular & Bulk)</p>
                                <p>Submit & Amend Shipping Instructions</p>
                                <p>Container Management</p>
                                <p>Address Book</p>
                                <p>AME Track</p>
                                <p>Dashboard</p>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex xs3 style="margin-left:20px">
                          <v-card style="margin-top:20px;height:360px">
                            <v-card-text>
                              <h3 style="text-align: left;margin-bottom: 10px;color:blue">Role: Employee</h3>
                              <v-divider divider: true></v-divider>
                                <p style="margin-top:20px">Book Shipment (Regular & Bulk)</p>
                                <p>Submit Shipping Instructions</p>
                                <p>Container Management</p>
                                <p>Address Book</p>
                                <p>AME Track</p>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex style="text-align: left" v-show="show3">
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2></v-flex>
                        <v-flex xs4 style="margin-left:20px;margin-right:20px">
                          <h3>Personal Details</h3>
                          <p style="margin-top:20px"><b>Full Name:</b> Rohit Supe</p>
                          <p><b>Email:</b> rohit.supe@gmail.com</p>
                          <p><b>Mobile No:</b> 9865321478</p>
                          <p><b>Country:</b> India</p>
                        </v-flex>
                        <v-divider vertical></v-divider>
                        <v-flex xs4 style="margin-left:20px;margin-right:20px">
                          <h3>company Details</h3>
                          <p style="margin-top:20px"><b>Company Name:</b> AME Logistic LLP</p>
                          <p><b>Address:</b> Sharjah</p>
                          <p><b>City:</b> Dammam</p>
                          <p><b>Postal Zip Code:</b> 123659</p>
                          <p><b>Country:</b> UAE</p>
                        </v-flex>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <v-layout style="margin-top:20px;margin-left:20px">
                        <v-flex>
                        <p>AME Logistics acknowledge that different companies have different permission needs for their employees</p>
                        <p>The security settings on your determine your permission</p>
                        <h3 style="margin-top: 20px">Your Access Permissions</h3>
                          <p style="margin-top:20px">Full Customer Panel Access</p>
                          <p>User Creation & assign roles</p>
                          <p>Maintain All the affiliate account</p>
                        </v-flex>
                      </v-layout >
                    </v-flex>
                  </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Name', value: 'name' },
        { text: 'User Name', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Mobile No', value: 'mobileno' },
        { text: 'Role', value: 'role' },
        { text: 'Password', value: 'password' },
        { text: 'Country', value: 'country' },
        { text: 'Action', value: 'action' }
      ],
      desserts: [
        {
          no: '1',
          name: 'Rohit Supe',
          username: 'rohit.supe',
          email: 'rohit.supe@gmail.com',
          mobileno: '98653214789',
          role: 'Master Admin',
          password: '*********',
          country: 'India'
        },
        {
          no: '2',
          name: 'Yogesh Wagh',
          username: 'yogesh.wagh',
          email: 'yogesh.wagh@gmail.com',
          mobileno: '98653214789',
          role: 'Admin',
          password: '*********',
          country: 'India'
        },
        {
          no: '3',
          name: 'Rahul Kadam',
          username: 'rahul.kadam',
          email: 'rahul.kadam@gmail.com',
          mobileno: '98653214789',
          role: 'Admin',
          password: '*********',
          country: 'India'
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      switch1: true,
      dialog: false,
      dialog1: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
    },
    activate (el) {
      this.active_el = el
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.active_el {
  background-color: #00C853;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue